import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getBaseUrl } from '@/redux/modules/config';
import { getCanonicalURL } from '@/redux/modules/landingPage';
import { addTrailingSlash, stripUrlQueryAndHash } from '@/utils/urls';

export const useGetSearchPageCanonicalUrl = () => {
    const { pathname } = useLocation();

    const baseUrl = useAppSelector(getBaseUrl);
    const canonicalURL = useAppSelector(getCanonicalURL);

    return useMemo(() => {
        const pathFromMeta = canonicalURL ? stripUrlQueryAndHash(canonicalURL) : pathname;

        return `${baseUrl}${addTrailingSlash(pathFromMeta)}`;
    }, [baseUrl, canonicalURL, pathname]);
};
